import api from './api'

export default {
  assuntos(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/integrations/osm/assuntos', { params })
  },
}
